import { render, staticRenderFns } from "./correct_class_test.vue?vue&type=template&id=3d59c9a3&scoped=true&"
import script from "./correct_class_test.vue?vue&type=script&lang=js&"
export * from "./correct_class_test.vue?vue&type=script&lang=js&"
import style0 from "./correct_class_test.vue?vue&type=style&index=0&id=3d59c9a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d59c9a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
